import axios from 'redaxios';
import FlashNotifications from "controllers/vue_components/flash_toast"

export default {
    components: {FlashNotifications},
    data() {
        return {}
    },
    methods: {
        async axiosRequest(type, endpoint_url, data, show_notifications = true) {
            try {
                let headers = this.requestHeaders
                let response = {}
                if (type === 'GET') {
                    response = await axios.get(endpoint_url, {headers})
                } else if (type === 'POST') {
                    response = await axios.post(endpoint_url, data, {headers});
                } else if (type === 'PUT') {
                    response = await axios.put(endpoint_url, data, {headers});
                } else if (type === 'DELETE') {
                    response = await axios.delete(endpoint_url, {headers, data});
                }

                if (show_notifications) {
                    if (response.data.success) {
                        this.$refs.flash.show(response.data.message, 'notice');
                    } else {
                        this.$refs.flash.show(response.data.error, 'alert');
                    }
                }
                return {js_error: false, response: response.data}
            } catch (error) {
                if (show_notifications) {
                    this.$refs.flash.show(this.I18N.notifications.bookings.something_wrong, 'alert');
                }
               console.log(error)
                return {js_error: true, error: error}

            }
        },

        async fetchCurrentUser() {
            let res = await this.axiosRequest('GET', '/api/v1/user', {}, false)
            if (res.js_error == false && res.response.success) {
                return res.response.data;
            } else {
                return {}
            }
        }
    },
    computed: {
        requestHeaders() {
            let header = {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('[name="csrf-token"]').getAttribute('content')
            }
            return header;
        }
    }, // To user the flash notification please add <FlashNotifications ref="flash" /> into your parent component as well
}
